export interface IUser {
  userId: string;
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  mobileNumber: string;
  gender?: string;
  address: string;
  dob?: string;
  role: string;
  orgType?: string;
  orgName?: string;
  profilePictureUrl?: string;
  governmentIDUrl?: string;
  reference: string;
  notification: string;
  userAddDate: Date;
  userStatus: number;
  profilePicture: string;
  identityID?: string;
  userAssetAccess?: string;
  isManuallyVerified?: string;
  isEmployee?: string;
  isNightShift?: string;
  isSelfAttendance?: string;
  isDownloadAllowed?: string;
  userLocation?: string;
  department?: string;
  employeeQR?: string;
  reportingRole?: string;
  reportingManagerId?: string;
}

export const initUser: IUser = {
  userId: null,
  firstName: null,
  lastName: null,
  username: null,
  email: null,
  mobileNumber: null,
  gender: null,
  address: null,
  dob: null,
  role: null,
  orgType: null,
  orgName: null,
  profilePictureUrl: null,
  governmentIDUrl: null,
  reference: null,
  notification: null,
  userAddDate: null,
  userStatus: 0,
  profilePicture: null,
  userAssetAccess: null,
  isManuallyVerified: null,
  isEmployee: null,
  isSelfAttendance: null,
  userLocation: null,
  department: null,
};

export interface UserRegDetails {
  orgID: string;
  userId: string;
  userName: string;
  firstname: string;
  lastname: string;
  email: string;
  phoneNumber: string;
  dateOfBirth?: Date;
  gender: string;
  userAddress: string;
  userRole: string;
  userStatus: number;
  userPassword?: string;
  identityID: string;
  profilePicture: string;
  additionalPhoto: string;
  selected?: boolean;
  locationAccess: string;
  vibrationAccess: string;
  userVehicles?: string;
  isManuallyVerified?: string;
  isEmployee?: string;
  isSelfAttendance?: string;
  isNightShift?: string;
  isDownloadAllowed?: string;
  userLocation?: string;
  employeeDepartment?: string;
  employeeQR?: string;
  employeeAttendance?: string;
  userAssetAccess?: string;
}
export const initUserRegDetails: UserRegDetails = {
  orgID: null,
  userId: null,
  userName: null,
  firstname: null,
  lastname: null,
  email: null,
  phoneNumber: null,
  dateOfBirth: null,
  gender: null,
  userAddress: null,
  userRole: null,
  userStatus: null,
  userPassword: null,
  identityID: null,
  profilePicture: null,
  additionalPhoto: null,
  selected: false,
  locationAccess: null,
  vibrationAccess: null,
  userVehicles: null,
  isManuallyVerified: null,
  isEmployee: null,
  isSelfAttendance: null,
  userLocation: null,
  employeeDepartment: null,
  employeeQR: null,
};
